import { graphql } from 'react-relay';

export const detailFilterFragment = graphql`
    fragment DetailFilter_detailFilter on DetailFilter {
        filtercategory {
            __typename
            ... on DetailFilterListCategory {
                col
                ...DetailFilterListCategory_category
            }
            ... on DetailFilterDropdownCategory {
                col
                ...DetailFilterDropdownCategory_category
            }
        }
        selectioninfo {
            ...DetailFilterSelectionInfo_selectionInfo
        }
    }
`;
